module.exports = __webpack_public_path__ + "static/img/17.000eb2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/images/certificate/banner/17.jpg
// module id = J7FK
// module chunks = 1